var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('populate-form',{ref:"profileForm",attrs:{"formTitle":_vm.role_type_name+'設定修改'+(_vm.profileTarget!=='merchant'?'-目前不開放修改':''),"fkey":"pf01","populateOptionVar":"formOptions","formDataObjVar":"formData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }